import { render, staticRenderFns } from "./TicketReports.vue?vue&type=template&id=51a4f934&"
import script from "./TicketReports.vue?vue&type=script&lang=ts&"
export * from "./TicketReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports